import { TravelRegion } from "../types/Travel/TravelRegion";
import { TransportOption } from "../types/Travel/TravelTransportOption";
import { City } from "./const";
import { TravelRangeType } from "./enum/travel";

export const TravelTransport: Record<string, TransportOption> = {
  Train: {
    cost: 250,
    travelType: "Train",
    travelTime: 240 * 60,
    travelRangeType: TravelRangeType.LocalTravel,
    icon: "/assets/imgs/travel/train.jpg",
    id: 0,
  },

  "Car/Motorcycle": {
    travelType: "Car/Motorcycle",
    cost: 750,
    travelTime: 120 * 60,
    travelRangeType: TravelRangeType.LocalTravel,
    icon: "/assets/imgs/travel/car.png",
    id: 1,
  },

  Airplane: {
    travelType: "Airplane",
    cost: 1750,
    icon: "/assets/imgs/travel/plane.png",
    travelTime: 60 * 60,
    travelRangeType: TravelRangeType.InterContinentalTravel,
    id: 2,
  },
};

export const TravelCities: TravelRegion[] = [
  {
    region: "North America",
    cities: [
      { name: City[0], cityId: 0 },
      { name: City[1], cityId: 1 },
      { name: City[2], cityId: 2 },
      { name: City[3], cityId: 3 },
      { name: City[4], cityId: 4 },
    ],
  },
  {
    region: "South America",
    cities: [
      { name: City[5], cityId: 5 },
      { name: City[6], cityId: 6 },
      { name: City[7], cityId: 7 },
    ],
  },
  {
    region: "Europe",
    cities: [
      { name: City[8], cityId: 8 },
      { name: City[9], cityId: 9 },
      { name: City[10], cityId: 10 },
    ],
  },
];
